import { useLingui } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { Button } from 'designSystem/components/Button'
import { Text } from 'designSystem/components/Text'
import { EvalPagePending } from 'features/knowledgeDocumentViewer/components/metadata/EvalPagePending'
import { PageMetadataEvalSection } from 'features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalSection'
import { useKnowledgeDocumentDataContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { usePageMetadataEvalSession } from 'features/knowledgeDocumentViewer/contexts/PageMetadataEvalSessionContext'
import { useEvalPageEdits } from 'features/knowledgeDocumentViewer/hooks/useEvalPageEdits'
import { useSystemDocumentPageByNum } from 'features/knowledgeDocumentViewer/hooks/useSystemDocumentPageByNum'
import { useGeckoPermissions } from 'features/permissions'

export function EvalMetadataSection() {
  const { t } = useLingui()
  const { currentPage } = usePageMetadataEvalSession()
  const { siteID } = useKnowledgeDocumentDataContext()
  const { user } = useGeckoPermissions()
  const {
    page,
    isLoading,
    error: pageError,
    retry: retryPage,
  } = useSystemDocumentPageByNum({
    bqDocumentId: currentPage?.document_id,
    pageNum: currentPage?.page_num,
    systemDocumentEntryId: undefined,
  })
  const {
    edits,
    error,
    deferReason,
    retry: retryEdits,
  } = useEvalPageEdits(
    siteID,
    currentPage?.document_id,
    currentPage?.page_num,
    user?.email
  )
  const handleRetry = () => {
    retryEdits()
    retryPage()
  }
  if (!currentPage) return null
  return (
    <Box
      display='flex'
      direction='column'
      flex='one'
      minHeight='none'
      paddingX='xl'
      paddingTop='lg'
      paddingBottom='md'
      border='top'>
      {error ? (
        <>
          <Text color='destructive'>{t`Could not load your saved page edits.`}</Text>
          <Button onClick={handleRetry}>{t`Retry loading saved edits`}</Button>
        </>
      ) : null}
      {!page ? (
        <EvalPagePending
          isLoading={isLoading && !pageError}
          onRetry={handleRetry}
        />
      ) : (
        <PageMetadataEvalSection
          key={`${page.entry.id}:${user?.email}`}
          pageEntry={page}
          pageNum={currentPage.page_num}
          bqDocumentId={currentPage.document_id}
          isLoading={isLoading || edits === undefined || !!error}
          pageUserEdits={edits ?? []}
          {...(deferReason === undefined ? {} : { deferReason })}
        />
      )}
    </Box>
  )
}
